import { render } from "./FormulasPreviewDisclaimer.vue?vue&type=template&id=a53a409e"
const script = {}

import "./FormulasPreviewDisclaimer.vue?vue&type=style&index=0&id=a53a409e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__